import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import type { UnitResponse } from "@offertli/shared";
import { apiGet } from "./api.js";

function supportedTranslationLocale(
  language: string | undefined,
): "de" | "fr" | "es" | null {
  const locale = language?.split("-")[0];
  return locale === "de" || locale === "fr" || locale === "es" ? locale : null;
}

export function useUnits() {
  const { t, i18n } = useTranslation();
  const query = useQuery({
    queryKey: ["units"],
    queryFn: () =>
      apiGet<{ data: UnitResponse[] }>("/settings/units").then(
        (response) => response.data,
      ),
  });
  const locale = supportedTranslationLocale(i18n.resolvedLanguage);
  const localizedName = (unit: UnitResponse): string =>
    (locale ? unit.translations[locale] : undefined) ??
    t(`settings.unitNames.${unit.code}`, { defaultValue: unit.name });
  const formatUnit = (code: string): string => {
    const unit = query.data?.find((candidate) => candidate.code === code);
    return unit ? localizedName(unit) : code;
  };
  return { ...query, localizedName, formatUnit };
}
